<template>
  <div>
    <router-link
      :to="{ name: 'GreetingView', params: { userId: greeting.userId } }"
      active-class="active"
      tag="div"
      v-for="greeting in greetings"
      :key="greeting.userId"
      class="contact-item d-flex px-3 py-3"
    >
      <div class="profile-image">
        <img v-if="greeting.profileImage" :src="greeting.profileImage" />
        <img v-else src="/static/icons/user-profile-default.png" />
      </div>
      <div class="contact-container flex-grow-1">
        <div class="d-flex">
          <h5 class="title">
            {{ greeting.firstName || "" }} {{ greeting.lastName || "" }}
          </h5>
          <div class="contact-date">
            {{ greeting.verifiedDate | moment-day-month }}
          </div>
        </div>
        <div class="contact-info">
          <span>{{ greeting.email }}</span><br/>
          <span>{{ " " }}{{ $t("feature.member.tel") }}</span>
          <span>{{ " " }}{{ greeting.mobileNumber || "-" }}</span><br/>
          <span>{{ greeting.userHome.home.addressNo}} {{ greeting.userHome.project.projectName }}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  props: {
    greetings: {
      type: Array
    }
  }
};
</script>
<style lang="scss" scoped>
.contact-item {
  cursor: pointer;
  border-bottom: solid 1px #f5f5f5;
  &.active {
    background: #efefef;
  }
  .profile-image {
    margin-right: 16px;
    img {
      width: 45px;
      height: 45px;
      object-fit: cover;
      border-radius: 10.5px;
    }
  }
  .title {
    flex: 1 1 auto;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    margin: 0 0 0px 0;
  }
  .contact-info {
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
  }
  .contact-date {
    flex: 1 0 auto;
    margin-left: 5px;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/greeting/GreetingNavigation.vue